<template>
  <div class="section">
    <div class="container">
      <ui-page-hero :title="$t('Views.Settings.LedgerNumbers.Main_Title')" />

      <div
        class="box"
        v-for="exportgroup in distinctExportgroups"
        :key="exportgroup.ExportgroupId"
      >
        <p class="title">{{ exportgroup.ExportgroupName }}</p>

        <table class="table is-fullwidth is-striped is-narrow is-hoverable">
          <thead>
            <tr>
              <th>
                {{ $t('Views.Settings.LedgerNumbers.TableHeader_ExportGroup') }}
              </th>
              <th class="has-text-right">
                {{ $t('Views.Settings.LedgerNumbers.TableHeader_TaxRate') }}
              </th>
              <th>&nbsp;</th>
              <th class="has-text-right">
                {{ $t('Views.Settings.LedgerNumbers.TableHeader_LedgerNumber') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="ln in filterLedgerNumbersOnExportgroupId(
                exportgroup.ExportgroupId
              )"
              :key="ln.Id"
            >
              <td>{{ ln.ExportgroupName }}</td>
              <td
                width="100"
                class="has-text-right"
              >
                {{ ln.TaxPercentage }} %
              </td>
              <td width="300">&nbsp;</td>
              <td
                width="125"
                class="has-text-right"
              >
                <input
                  type="text"
                  class="input"
                  width="5"
                  :disabled="isSaving"
                  v-model="ln.Number"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="has-text-right">
        <a
          @click="saveLocationLedgerNumbers"
          class="button is-primary"
          :class="{ 'is-loading': isSaving }"
        >{{ $t('Views.Settings.LedgerNumbers.Button_Save') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import ledgernumberProvider from '@/providers/ledgernumber'
import EventBus from '../../eventbus/event-bus'

export default {
  data() {
    return {
      isSaving: false,
      locationId: Number(this.$route.params.locationId),
      ledgernumbers: []
    }
  },

  computed: {
    distinctExportgroups() {
      let exportgroups = []

      if (this.ledgernumbers && this.ledgernumbers.length > 0) {
        for (let i = 0; i < this.ledgernumbers.length; i++) {
          if (
            exportgroups.findIndex(
              e => e.ExportgroupId === this.ledgernumbers[i].ExportgroupId
            ) === -1
          ) {
            exportgroups.push({
              ExportgroupId: this.ledgernumbers[i].ExportgroupId,
              ExportgroupName: this.ledgernumbers[i].ExportgroupName
            })
          }
        }
      }

      return exportgroups
    }
  },

  created() {
    this.getLocationLedgernumbers()
  },

  methods: {
    getLocationLedgernumbers() {
      let self = this

      ledgernumberProvider.methods
        .getLocationLedgernumbers(this.locationId)
        .then(response => {
          if (response.status === 200) {
            self.ledgernumbers = response.data
          }
        })
    },

    filterLedgerNumbersOnExportgroupId(exportgroupId) {
      return this.ledgernumbers.filter(l => l.ExportgroupId === exportgroupId)
    },

    saveLocationLedgerNumbers() {
      if (this.isSaving) { return }

      this.isSaving = true
      ledgernumberProvider.methods
        .saveLocationLedgerNumbers(this.locationId, this.ledgernumbers)
        .then(() => {
          EventBus.$emit('showToast', {
            type: 'info',
            message: this.$t('Views.Settings.LedgerNumbers.Toast_LedgerNumbersSaved'),
          })
        })
        .finally(() => {
          this.isSaving = false
        })
    }
  }
}
</script>
